import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { listPrestations, deletePrestation } from "../services/api";
import Popup from "./Popup";
import "./SalarieList.css";

const PrestationList = () => {
  const [prestations, setPrestations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletePopup, setDeletePopup] = useState({
    isOpen: false,
    prestation: null,
  });
  const [deleteLoading, setDeleteLoading] = useState(null);
  const navigate = useNavigate();

  const loadPrestations = async () => {
    setLoading(true);
    try {
      const data = await listPrestations();
      console.log("Loaded prestations:", data); // Debug log
      setPrestations(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("PrestationList - Error loading:", err);
      alert("Erreur lors du chargement des prestations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPrestations();
    // eslint-disable-next-line
  }, []);

  const handleDelete = (id) => {
    const prestation = prestations.find((p) => p.id === id);
    setDeletePopup({ isOpen: true, prestation });
  };

  const confirmDelete = async () => {
    const id = deletePopup.prestation?.id;
    if (!id) return;
    setDeleteLoading(id);
    try {
      await deletePrestation(id);
      setPrestations((prev) => prev.filter((p) => p.id !== id));
      setDeletePopup({ isOpen: false, prestation: null });
    } catch (err) {
      alert("Erreur lors de la suppression.");
    } finally {
      setDeleteLoading(null);
    }
  };

  const cancelDelete = () => {
    setDeletePopup({ isOpen: false, prestation: null });
  };

  if (loading) return <div>Chargement...</div>;

  return (
    <div className="salarie-list-container">
      {/* Modern styling for prestations table */}
      <style>
        {`
          .salarie-list-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 2rem;
            background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
            min-height: 100vh;
          }
          
          .prestations-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
            flex-wrap: wrap;
            gap: 1rem;
          }
          
          .salarie-list-title {
            font-size: 2.25rem;
            font-weight: 700;
            background: linear-gradient(135deg, #1e3a8a, #3b82f6, #8b5cf6);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin: 0;
            text-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          .add-btn {
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            color: white;
            padding: 0.75rem 1.5rem;
            border-radius: 12px;
            text-decoration: none;
            font-weight: 600;
            font-size: 0.95rem;
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
            transition: all 0.3s ease;
            border: none;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
          }
          
          .add-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6);
            background: linear-gradient(135deg, #2563eb, #1e40af);
          }
          
          .prestations-table-wrapper {
            background: white;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
            border: 1px solid #e5e7eb;
          }
          
          .prestations-table-scroll {
            overflow-x: auto;
            scrollbar-width: thin;
            scrollbar-color: #cbd5e1 transparent;
          }
          
          .prestations-table-scroll::-webkit-scrollbar {
            height: 8px;
          }
          
          .prestations-table-scroll::-webkit-scrollbar-track {
            background: #f1f5f9;
          }
          
          .prestations-table-scroll::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
          
          .prestations-table-scroll::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
          
          .salarie-list-table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            font-size: 0.95rem;
          }
          
          .salarie-list-table thead th {
            background: linear-gradient(135deg, #f8fafc, #e2e8f0);
            color: #1e293b;
            font-weight: 700;
            font-size: 0.8rem;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            padding: 1.25rem 1.5rem;
            text-align: left;
            border-bottom: 2px solid #e2e8f0;
            position: sticky;
            top: 0;
            z-index: 10;
          }
          
          .salarie-list-table thead th:first-child {
            border-top-left-radius: 16px;
          }
          
          .salarie-list-table thead th:last-child {
            border-top-right-radius: 16px;
          }
          
          .salarie-list-table tbody tr {
            background: white;
            transition: all 0.3s ease;
            border-bottom: 1px solid #f1f5f9;
          }
          
          .salarie-list-table tbody tr:nth-child(even) {
            background: #fafbfc;
          }
          
          .salarie-list-table tbody tr:hover {
            background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          }
          
          .salarie-list-table tbody tr:last-child:hover td:first-child {
            border-bottom-left-radius: 16px;
          }
          
          .salarie-list-table tbody tr:last-child:hover td:last-child {
            border-bottom-right-radius: 16px;
          }
          
          .salarie-list-table td {
            padding: 1rem 1.5rem;
            color: #334155;
            vertical-align: middle;
            border-bottom: 1px solid #f1f5f9;
          }
          
          .salarie-list-table tbody tr:last-child td {
            border-bottom: none;
          }
          
          .prestation-name {
            font-weight: 600;
            color: #1e293b;
            font-size: 1rem;
          }
          
          .prix-badge {
            background: linear-gradient(135deg, #dbeafe, #bfdbfe);
            color: #1e40af;
            font-weight: 700;
            padding: 0.5rem 1rem;
            border-radius: 12px;
            font-size: 0.9rem;
            display: inline-flex;
            align-items: center;
            gap: 0.25rem;
            border: 1px solid #93c5fd;
            box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
          }
          
          .actions-cell {
            display: flex;
            gap: 0.75rem;
            align-items: center;
          }
          
          .salarie-action-btn {
            padding: 0.5rem 1rem;
            border-radius: 8px;
            font-size: 0.85rem;
            font-weight: 600;
            border: none;
            cursor: pointer;
            transition: all 0.2s ease;
            text-transform: uppercase;
            letter-spacing: 0.05em;
          }
          
          .salarie-action-btn.edit {
            background: linear-gradient(135deg, #10b981, #059669);
            color: white;
            box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
          }
          
          .salarie-action-btn.edit:hover {
            background: linear-gradient(135deg, #059669, #047857);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
          }
          
          .salarie-action-btn.delete {
            background: linear-gradient(135deg, #ef4444, #dc2626);
            color: white;
            box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
          }
          
          .salarie-action-btn.delete:hover {
            background: linear-gradient(135deg, #dc2626, #b91c1c);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
          }
          
          .salarie-action-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none !important;
          }
          
          .empty-state {
            text-align: center;
            padding: 4rem 2rem;
            background: white;
            border-radius: 16px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            color: #64748b;
            font-size: 1.1rem;
            border: 2px dashed #e2e8f0;
          }
          
          /* Mobile responsive design */
          @media (max-width: 768px) {
            .salarie-list-container {
              padding: 1rem;
            }
            
            .prestations-header {
              flex-direction: column;
              align-items: stretch;
              text-align: center;
            }
            
            .salarie-list-title {
              font-size: 1.75rem;
            }
            
            .prestations-table-scroll {
              font-size: 0.85rem;
            }
            
            .salarie-list-table thead {
              display: none;
            }
            
            .salarie-list-table,
            .salarie-list-table tbody,
            .salarie-list-table tr,
            .salarie-list-table td {
              display: block;
              width: 100%;
            }
            
            .salarie-list-table tr {
              background: white;
              margin-bottom: 1rem;
              padding: 1rem;
              border-radius: 12px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              border: 1px solid #e5e7eb;
            }
            
            .salarie-list-table td {
              border: none;
              padding: 0.5rem 0;
              position: relative;
              padding-left: 40%;
            }
            
            .salarie-list-table td:before {
              content: attr(data-label);
              position: absolute;
              left: 0;
              width: 35%;
              padding-right: 1rem;
              white-space: nowrap;
              font-weight: 600;
              color: #64748b;
              font-size: 0.8rem;
              text-transform: uppercase;
              letter-spacing: 0.05em;
            }
            
            .actions-cell {
              flex-direction: column;
              gap: 0.5rem;
              align-items: stretch;
            }
            
            .salarie-action-btn {
              width: 100%;
              justify-content: center;
            }
          }
        `}
      </style>
      
      <div className="prestations-header">
        <h2 className="salarie-list-title">Liste des prestations</h2>
        <Link to="/prestations/add" className="add-btn">
          ✨ Ajouter Prestation
        </Link>
      </div>
      
      {prestations.length === 0 ? (
        <div className="empty-state">
          📋 Aucune prestation trouvée.<br />
          <small>Commencez par ajouter votre première prestation.</small>
        </div>
      ) : (
        <div className="prestations-table-wrapper">
          <div className="prestations-table-scroll">
            <table className="salarie-list-table">
              <thead>
                <tr>
                  <th>Type de prestation</th>
                  <th>Prix heure (€)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {prestations.map((p) => (
                  <tr key={p.id}>
                    <td data-label="Type" className="prestation-name">
                      {p.name || "Nom non défini"}
                    </td>
                    <td data-label="Prix">
                      <span className="prix-badge">
                        💰 {Number(p.prix_heure || 0).toFixed(2)} €
                      </span>
                    </td>
                    <td data-label="Actions">
                      <div className="actions-cell">
                        <button
                          className="salarie-action-btn edit"
                          onClick={() => navigate(`/prestations/edit/${p.id}`)}
                        >
                          ✏️ Modifier
                        </button>
                        <button
                          className="salarie-action-btn delete"
                          onClick={() => handleDelete(p.id)}
                          disabled={deleteLoading === p.id}
                        >
                          {deleteLoading === p.id ? "⏳ Suppression..." : "🗑️ Supprimer"}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Popup
        isOpen={deletePopup.isOpen}
        onClose={cancelDelete}
        onConfirm={confirmDelete}
        title="Confirmer la suppression"
        type="warning"
        showCancel={true}
      >
        <div className="delete-salarie-confirmation">
          <p>Êtes-vous sûr de vouloir supprimer cette prestation ?</p>
          {deletePopup.prestation && (
            <div className="salarie-info-popup">
              <div>
                <span className="popup-label">Type :</span>{" "}
                <span className="popup-value">
                  {deletePopup.prestation.name}
                </span>
              </div>
              <div>
                <span className="popup-label">Prix heure :</span>{" "}
                <span className="popup-value">
                  {deletePopup.prestation.prix_heure} €
                </span>
              </div>
            </div>
          )}
          <div className="popup-warning-text">
            ⚠️ Cette action est irréversible !
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default PrestationList;
